module.exports = __webpack_public_path__ + "img/hero-text.da5a75bd.svg";